import React from 'react';
import LoginForm from '../parts/LoginForm';
import {metaDescriptions, metaTitles, title} from "../website-utils/meta";
import {Helmet} from "react-helmet";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";
import BusinessHeaderBare from "../parts/BusinessHeaderBare";
import {Link} from "react-router-dom";
import config from "../config";


export default class BusinessLoginPage extends React.Component {
  componentDidMount() {
    window.analytics.page("Business", "Log In");
  }

  render() {
    return (
      <div className={'business login'}>
        <Helmet>
          {title('SingleShift - Business Log In')}
          {metaTitles('SingleShift - Business Log In')}
          {metaDescriptions('Log In Page')}
        </Helmet>
        <ScrollToTopOnMount/>
        <div className="container">
          <BusinessHeaderBare/>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <h2>Sign In</h2>
            </div>
          </div>
          <div className="singleshift-form">
            <LoginForm/>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6 account-nav text-center">
              <small>Don't have an account? <Link to={config.routes.businessSignUp}>Register here</Link></small>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/BusinessLoginPage.js